/* eslint-disable max-len */
export const errors = {
  'service-is-unavailable': 'Сервис убактылуу жеткиликсиз, кийинчерээк аракет кылыңыз',
  'cannot-get-telegram-link': 'Telegramга шилтеме алынбай калды',
  'maybe-error': 'Мүмкүн, ката кеткендир',
  'check-email': 'Сиз менен байланышуу үчүн e-mail дарегиңиздин туура экенин текшериңиз.',
  'check-input-correctness': 'Туура жазылгандыгын текшериңиз!',
  'link-possibly-expired': 'Шилтемеңиз эскирген же шаблон жок болушу мүмкүн. СМ колдоо кызматына кайрылыңыз',
  'interview-has-already-been-recorded': 'Жумуш маеги эчак жазылган',
  'use-are-using-outdated-browser': 'Тилекке каршы, сиздин браузериңиз заманбап технологияларды колдобойт жана видео жаздыруу сыяктуу айрым функциялар жеткиликсиз болушу мүмкүн. Сайттын туура иштеши жана маалыматты көрсөтүшү үчүн Chrome, FireFox же Edge браузерлерин колдонуңуз.',
  'questionnaire-was-not-sent': 'Анкета жиберилген жок',
  'check-data-correctness': 'Киргизилип жаткан маалыматтын тууралыгын текшериңиз.',
  error: 'Ката',
  'connot-load-questionnaire-template': 'Анкетанын шаблону жүктөлбөй калды, колдоо кызматына кайрылыңыз.',
  'somthing-went-wrong-try-leter': 'Бир жерден ката кетти. Баракчаны кийинчерээк ачып көрүңүз.',
  'no-answer-was-sent': 'Жооп жиберилген жок',
  'you-can-choose-only-one-variant': 'Бир гана вариантты тандоого болот',
  'full-name-must-contain-three-words': 'ФАА талаасы арасында бош орундарды камтып, так үч сөздөн турушу керек!',
  'phone-must-have-format': 'Телефон номери +996 (NNN) NNN-NNN форматында болушу керек!',
  'video-interview-has-already-been-created': 'Видеоинтервью түзүлдү, жумуш маегинен өтүңүз.',
};
